import { useQuery } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";

export const useGetAllBranch = (page: number, limit: number) => {
    return useQuery({
        queryKey: ["branches", page, limit],
        queryFn: () => adminApi.getAllBranch({ page, limit }),
    });
};
